import {z} from 'zod'

export const dischargeConfigSchema = z.discriminatedUnion('method', [
  z.object({
    method: z.literal('boom')
  }),
  z.object({
    method: z.literal('hose'),
    hoseLength: z.number()
  })
])

export const pumpSettingsSchema = z.object({
  canLargerPumpFit: z.boolean(),
  isPossibleToCleanPumpOnSite: z.boolean(),
  discharge: dischargeConfigSchema
})

export const pumpFormSchema = z.object({
  pumpNumber: z.string(),
  pumpSettings: pumpSettingsSchema
})

export const unloadingMethodFormSchema = z.object({
  unloadingMethod: z
    .object({
      unloadingMethodCode: z.string().optional(),
      pump: pumpFormSchema.optional()
    })
    .optional()
})
